<template>
    <div class="r:100 b:1|solid|#CECECE bg:white px:16 rel {border-color:primary;box-shadow:0|0|0|3|#538BD433}.entered" :class="{ entered }" @click.stop>
        <part-search @blur="entered = false" class="flex ai:center w:full" @focus="entered = true" v-bind="$attrs"></part-search>
    </div>
</template>

<script setup>
    const entered = ref(false);
</script>
